import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import Badge from '../../../components/Badge';
import MyDataTable from '../../../components/MyDataTable';
import Container from '../../../components/Container';

interface ImageProviderCompany {
    companyName: string;
    integrationId: string;
    isSelf?: boolean;
}

interface ImageProviderCompaniesTabProps {
    imageProviderCompanies: ImageProviderCompany[];
}

export default function ImageProviderCompanies({ imageProviderCompanies }: ImageProviderCompaniesTabProps) {
    const { styles } = useStyles(styleSheet);

    if (!imageProviderCompanies || imageProviderCompanies.length === 0) {
        return (
            <View>
                <MyAppText style={styles.emptyText}>
                    {translate('noImageProviderCompanies')}
                </MyAppText>
            </View>
        );
    }

    return (
        <Container>
            <View style={styles.headerRow}>
                <MyAppText style={styles.countText}>
                    {translate('totalImageProviderCompanies', { count: imageProviderCompanies.length })}
                </MyAppText>
            </View>

            <MyDataTable
                data={imageProviderCompanies}
                columns={[{
                    name: translate('companyName'),
                    cell: row => (
                        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                            <MyAppText>{row.companyName}</MyAppText>
                            {row.isSelf && (
                                <Badge mode='ROUNDED' backgroundColor='#00BA39' size='small'>
                                    {translate('cloudProvider')}
                                </Badge>
                            )}
                        </View>
                    ),
                    grow: 2
                }, {
                    name: translate('integrationId'),
                    selector: row => row.integrationId,
                }]}
            />
        </Container>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    emptyText: {
        fontSize: 14,
        fontWeight: '400',
        color: theme.colors.neutral['500'],
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
    },
    countText: {
        fontSize: 14,
        fontWeight: '500',
        color: theme.colors.neutral['500'],
    },
    row: {
        flexDirection: 'row',
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderColor: theme.colors.neutral['100'],
    }
}));
